/**
 * Constants for tracking which UI component triggered a trial-to-paid upgrade.
 * These values are sent as the `activationSource` attribute in the
 * `paymentsActivateTrial` mutation so the backend can track activation
 * and refund rates per component.
 *
 * Naming convention: <domain>_<flow/page>_<UI component>
 */

export const UPGRADE_SOURCES = {
  // Marketplace upgrade sources
  MARKETPLACE_TRIAL_FLOW_WELCOME_POPUP: 'marketplace_trial_flow_welcome_popup',
  MARKETPLACE_TRIAL_FLOW_PAGE2_CTA: 'marketplace_trial_flow_page2_cta',
  MARKETPLACE_TRIAL_FLOW_PAGE2_POPUP: 'marketplace_trial_flow_page2_popup',
  MARKETPLACE_ACTIVE_TRIAL_POPUP: 'marketplace_active_trial_popup',
  MARKETPLACE_ACTIVE_TRIAL_TOP_BANNER: 'marketplace_active_trial_top_banner',
  MARKETPLACE_DESIGNER_PRODUCT_PAGE_TOGGLE: 'marketplace_designer_product_page_toggle',
  MARKETPLACE_AI_PRODUCT_PAGE_TOGGLE: 'marketplace_ai_product_page_toggle',
  MARKETPLACE_PRODUCT_PAGE_ACTIVATE_TRIAL_BUTTON: 'marketplace_product_page_activate_trial_button',
  MARKETPLACE_MY_ACCOUNT_ACTIVATE_SUBSCRIPTION_BUTTON:
    'marketplace_my_account_activate_subscription_button',
  MARKETPLACE_HALLOWEEN_UPGRADE_BUTTON: 'marketplace_halloween_upgrade_button',
  BOTTOM_VIEWPORT_BANNER: 'bottom_viewport_banner',
  MARKETPLACE_PDP_STUDIO_WIDGET: 'marketplace_pdp_studio_widget',

  // Studio upgrade sources
  STUDIO_TRIAL_FLOW_WELCOME_POPUP: 'studio_trial_flow_welcome_popup',
  STUDIO_TRIAL_FLOW_WELCOME_POPUP_2: 'studio_trial_flow_welcome_popup_2',
  STUDIO_ALL_LEFT_SIDEBAR: 'studio_all_left_sidebar',
  STUDIO_COINS_BANNER: 'studio_coins_banner',
  STUDIO_REFERRALS_LEADERBOARD: 'studio_referrals_leaderboard',
  STUDIO_REFERRALS_BANNER: 'studio_referrals_banner',
  STUDIO_REFERRALS_INVITE_BANNER: 'studio_referrals_invite_banner',
  STUDIO_AI_EXCLUSIVE_OFFER_SCREEN: 'studio_ai_exclusive_offer_screen',
  STUDIO_CHAT_SIDEBAR: 'studio_chat_sidebar',

  // Cancel flow upgrade sources
  MARKETPLACE_CANCEL_FLOW_TRIAL_RECOVERY: 'marketplace_cancel_flow_trial_recovery',
} as const

export type UpgradeSource = (typeof UPGRADE_SOURCES)[keyof typeof UPGRADE_SOURCES]
